document.addEventListener("on:cart:add", (event) => {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      // Monetate Begins
      window.monetateQ = window.monetateQ || [];
      // 1. Set the Page Type
      window.monetateQ.push(["setPageType", "Cart"]);
      // 2. Set the Page Categories
      // This includes your custom 'addedToCart' alongside regional markers
      window.monetateQ.push([
        "addCategories",
        [
          "addedToCart",
          Shopify.locale,
          Shopify.country,
          Shopify.currency.active,
        ],
      ]);
      let lineItems = [];
      // Access line items
      cart.items.forEach((item) => {
        let itemRead = {
          productId: item.product_id,
          quantity: item.quantity,
          unitPrice: item.final_price,
          sku: item.sku,
          currency: cart.currency.iso_code,
        };
        lineItems = [...lineItems, itemRead];
      });
      // 3. Add the Cart Rows
      window.monetateQ.push(["addCartRows", [...lineItems]]);
      window.monetateQ.push(["trackData"]);
      //Monetate Ends
    });
});